import { Link } from "react-router-dom";

const contentLinks = [
  { label: "电影分类", to: "/category/movie" },
  { label: "电视剧分类", to: "/category/tv" },
  { label: "影视资讯", to: "/news" },
  { label: "专题策划", to: "/special" },
  { label: "站内搜索", to: "/search" },
];

const aboutLinks = [
  { label: "关于午夜影院", to: "/about" },
  { label: "免责声明", to: "/about" },
  { label: "内容合作", to: "/about" },
  { label: "意见反馈", to: "/about" },
];

const friendLinks = [
  { label: "光影资料馆", href: "https://911gugu2.asia" },
  { label: "城市放映计划", href: "https://911gugu2.asia" },
  { label: "剧集观察", href: "https://911gugu2.asia" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">午夜影院</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300/80">
              午夜影院是一个专注电影与电视剧的内容门户。我们用清晰的分类、详实的资料与编辑视角的专题，帮助你更快找到想看的那一部。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-50/15 text-background-300"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">内容导航</h3>
            <ul className="mt-4 space-y-2.5">
              {contentLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300/80 transition-colors duration-300 hover:text-secondary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">关于本站</h3>
            <ul className="mt-4 space-y-2.5">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300/80 transition-colors duration-300 hover:text-secondary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-secondary-400" />
                hello@midnightcinema.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-secondary-400" />
                每日 10:00 - 24:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-secondary-400" />
                内容编辑部 · 线上运营
              </li>
            </ul>
            <div className="mt-5">
              <p className="font-label text-[11px] uppercase tracking-[0.18em] text-secondary-400">
                友情链接
              </p>
              <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1.5">
                {friendLinks.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whitespace-nowrap text-xs text-background-300/70 transition-colors duration-300 hover:text-secondary-300"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/10 pt-6 text-xs text-background-400 md:mt-12 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 午夜影院 Midnight Cinema. 内容仅为演示用途。</p>
          <p className="text-background-400/80">
            本站不提供影片播放与下载，所有图文资料仅用于内容展示与交流。
          </p>
        </div>
      </div>
    </footer>
  );
}